import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This component manages the document title dynamically based on the current route
const PageTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Map of routes to page titles
    const routeTitles = {
      '/': 'Home - IMCAA',
      '/WhoWeAre': 'About Us - IMCAA',
      '/ConnectWithUs': 'Contact - IMCAA',
      '/Programmes': 'Our Programmes - IMCAA',
      '/Projects': 'Projects - IMCAA',
      '/EventsAndNews': 'Events & News - IMCAA',
      '/WalkWithUs': 'Walk With Us - IMCAA',
      '/Donate': 'Support Our Mission - IMCAA'
    };
    
    // Set the document title based on the current path
    const title = routeTitles[location.pathname] || 'IMCAA - Indigenous Maasai Climate Adaptation Alliance';
    document.title = title;
  }, [location]);
  
  return null; // This component doesn't render anything
};

export default PageTitle;